<template lang="pug">
v-card.pa-3.areas-list--features( flat color="info" v-if="mappedFeatures.length")
	div(v-for="feature in mappedFeatures")
		h3.d-inline-block.mr-1
			feature-icon(:rating="feature.rating" size="20")
			| {{$t(`feature_title.${feature.type}_${feature.rating}`)}}
		v-chip.px-2.py-0(label small color="primary" v-if="feature.rating === 4" style="height:20px") tip
		p
			ws-content.featuretext(:markdown="feature.text")
			a.never-visited(v-if="!visibleResortFeatures.includes(feature.type) && selectedResortFeatures.includes(feature.type)" href="#" @click.prevent="visibleResortFeatures.push(feature.type)")
				|
				| {{$t('areas_list_item.features_per_resort')}}
				ws-icon(small color="primary") double-angle-down
		v-card.pa-3.mb-2(v-if="selectedResortFeatures.includes(feature.type) && visibleResortFeatures.includes(feature.type)" flat)
			div(v-for="resort in feature.resorts" :key="`features-${feature.type}${resort.id}`")
				h4.d-inline-block.mr-1
					feature-icon(:rating="resort.rating" size="20")
					| {{resort.name}}
				v-chip.px-2.py-0(label small color="primary" v-if="resort.rating === 4" style="height:20px") tip
				ws-content(:markdown="resort.text")
</template>

<style lang="sass">
.areas-list--features
	.featuretext
		display: inline

		.md-generated, p
			display: inline
</style>

<script>
const FeatureIcon = {
	name: 'FeatureIcon',
	functional: true,
	render(createElement, context) {
		const rating = context.props.rating;
		context.props.color =
			context.props.color ||
			['', 'error', 'warning', 'success', 'success'][rating];
		return createElement('ws-icon', { props: context.props }, [
			['', 'minus', 'tilde', 'plus', 'plus'][rating]
		]);
	}
};

export default {
	components: {
		FeatureIcon
	},
	props: {
		features: {
			type: Array,
			required: true
		},
		area: {
			type: Object,
			required: true
		},
		matchingResortIds: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			visibleResortFeatures: []
		};
	},
	computed: {
		selectedResortFeatures() {
			return [
				'authentic',
				'location',
				'kids',
				'apresski',
				'price'
			].filter(feature => this.features.includes(feature));
		},
		mappedFeatures() {
			return this.features
				.map(feature => {
					let areaFeature =
						this.area.features.find(
							areafeature => areafeature.type.toLowerCase() === feature
						) || {};

					const resorts = this.area.resorts.nodes
						.map(resort => {
							const resortFeature = resort.features.find(
								resortfeature => resortfeature.type.toLowerCase() === feature
							);
							if (!resortFeature) {
								return false;
							}
							return {
								id: resort.id,
								name: resort.name,
								...resortFeature
							};
						})
						.filter(resort => !!resort);

					if (['authentic', 'location'].includes(feature)) {
						const matchingResorts = resorts
							.filter(resort => resort.rating >= 3)
							.map(resort => resort.name);
						areaFeature = {
							text: this.$tc(
								`areaslist.feature.${feature}text`,
								matchingResorts.length,
								{ resort: matchingResorts.join(', ') }
							),
							rating: Math.max.apply(
								Math,
								resorts.map(resort => resort.rating)
							)
						};
					}

					return {
						...areaFeature,
						type: feature,
						resorts: resorts.filter(resort =>
							this.matchingResortIds.includes(resort.id)
						)
					};
				})
				.filter(
					feature => !!feature.rating && [1, 2, 3, 4].includes(feature.rating)
				);
		},
		resortFeatures() {
			return this.area.resorts.nodes.map(resort => {
				return {
					...resort,
					features: this.selectedResortFeatures.reduce((carry, feature) => {
						carry[feature] =
							resort.features.find(
								resortfeature => resortfeature.type.toLowerCase() === feature
							) || {};
						return carry;
					}, {})
				};
			});
		}
	}
};
</script>
